/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { CircularProgress, Paper, Theme } from '@mui/material';
import Grid from '@mui/material/Grid';
import LegacyGrid from './legacy/LegacyGrid';
const GridAny: any = Grid;
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { exportTrainingAuthorizationPdf } from '../common/AuthorizationModel';
import { categories, Category } from '../common/Categories';
import { exportData, getAuthorizationDoughnutData, sendRequestAndReceiveResponse } from '../common/common';
import { fetchAuthorizationsEndpoint } from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';
import { history } from '../store/history';
import { dataTableRenderer, getExportQueryFromGridRequest, loadTableData } from './AuthorizationRenderer';
import DoughnutChart from './DoughnutChart';
import GroupedColumnChart from './GroupedColumnChart';

interface Props {
    classes?: any;
}
const styles = (theme: Theme) => ({
    table: {
        width: '100%',
        padding: '12px'
    },
    grid: {
        justifyContent: 'space-between',
        alignItems: 'center'
    }, progress: {
        margin: ((theme as any) && typeof (theme as any).spacing === 'function') ? (theme as any).spacing(2) : '16px'
    },
    progressWrap: {
        textAlign: 'center' as const,
        marginTop: '20vh'
    },
    message: {
        borderRadius: '0px',
        textAlign: 'center' as 'center',
        padding: '20px',
        marginTop: '20px'
    }
});

class TeamTrainingAuthorizations extends React.Component<Props>{
    state = {
        selectedCategory: categories.find((category: Category) => { return category.id === 9; }),
        xaxisData: [],
        dataSets: [],
        doughnutLabel: [],
        doughnutData: [],
        doughnutImageNames: [],
        rows: [],
        totalRows: 0,
        isLoading: true,
        isinitialLoading: true,
        isChartLoading: true,
        isModuleEnabled: false
    };
    componentDidMount() {
        console.log('TeamTrainingAuthorizations - componentDidMount');
        const enabledModules: Array<any> = loadFromLocalStorage('Enabled Modules');
        let isModuleEnabled = false;
        if (this.state.selectedCategory !== undefined) {
            isModuleEnabled = enabledModules !== undefined ? enabledModules.find(x => this.state.selectedCategory !== undefined &&
                x.modulename === this.state.selectedCategory.moduleName) !== undefined : false;
        }
        console.log('TeamTrainingAuthorizations - isModuleEnabled:', isModuleEnabled, 'enabledModules:', enabledModules);
        this.setState({ isModuleEnabled });
        if (!isModuleEnabled) {
            console.warn('TeamTrainingAuthorizations - Module not enabled, redirecting');
            history.push('/app/authorization');
            return;
        }
        console.log('TeamTrainingAuthorizations - Loading data...');
        this.loadData();
        this.loadTableData({ pageno: 1, pagesize: 10 });
    }
    async loadData() {
        if (this.state.selectedCategory !== undefined) {
            const colChartData = await sendRequestAndReceiveResponse(this.state.selectedCategory.requestBodyforColChart, fetchAuthorizationsEndpoint);
            const xaxisData: any = [], yaxisData: any = [], datasets: any = [], doughnutLabel: any = [], doughnutData: any = [], doughnutImageNames: any = [];
            if (colChartData !== undefined && colChartData.data !== undefined && colChartData.data.userTrainingRelation !== undefined &&
                colChartData.data.userTrainingRelation.data !== undefined && colChartData.data.userTrainingRelation.data.length) {
                colChartData.data.userTrainingRelation.data.forEach((x: any) => {
                    xaxisData.push(`${x.firstName} ${x.lastName}`);
                    yaxisData.push(x.numberOfAuthorizations);
                });
                datasets.push({
                    name: this.state.selectedCategory.yaxisLabel,
                    data: yaxisData
                });
            }
            const pieChartData = await sendRequestAndReceiveResponse(this.state.selectedCategory.requestBodyfoPieChart, fetchAuthorizationsEndpoint);
            if (pieChartData !== undefined && pieChartData.data !== undefined && pieChartData.data.productTrainingRelation !== undefined &&
                pieChartData.data.productTrainingRelation.data !== undefined && pieChartData.data.productTrainingRelation.data.length) {
                var result: any = getAuthorizationDoughnutData(pieChartData.data.productTrainingRelation.data);
            }
            if (result !== undefined) {
                result.forEach((i: any) => {
                    doughnutLabel.push(i.twodproductname);
                    doughnutData.push(i.numberOfAuthorizations);
                    doughnutImageNames.push(i.productLine);
                });
            }
            this.setState({ dataSets: datasets, xaxisData, doughnutLabel, doughnutData, doughnutImageNames, isChartLoading: false });
        }
    }
    async loadTableData(extras: any) {
        if (this.state.selectedCategory !== undefined) {
            this.setState({ isLoading: true, rows: [] });
            const data = await loadTableData(extras, this.state.selectedCategory);
            if (data !== undefined) {
                this.setState({ rows: data.rows, totalRows: data.totalRows, isLoading: false, isinitialLoading: false });
            }
        }

    }
    refreshChart() {

    }
    handleExport = async (exportType: any, selectedColumns: any) => {
        const mode = 'p';
        const columnHeaders: Object = exportTrainingAuthorizationPdf, fileName = 'TeamTrainingAuthorizations';
        try {
            if (navigator.onLine) {
                if (this.state.selectedCategory !== undefined) {
                    const data = await loadTableData(
                        getExportQueryFromGridRequest(this.state.selectedCategory.requestBodyForGrid),
                        this.state.selectedCategory
                    );
                    if (data !== undefined) {
                        exportData(selectedColumns, data.rows, exportType, fileName, columnHeaders, mode);
                    }
                }

            }
        } catch (e) { }
    };
    render() {
        const { classes } = this.props;
        const { dataSets, xaxisData, doughnutLabel, doughnutData, doughnutImageNames } = this.state;
        const { isinitialLoading, selectedCategory, rows, totalRows, isLoading, isModuleEnabled } = this.state;

        return (
            isModuleEnabled && <Grid>
                {this.state.isChartLoading ?
                    (
                        <div className={classes.progressWrap}>
                            <CircularProgress className={classes.progress} color="secondary" />
                        </div>
                    ) :
                    dataSets !== undefined && dataSets.length > 0 ? (<div>
                        <LegacyGrid container className={classes.grid}>
                            {selectedCategory !== undefined && (
                                <LegacyGrid item xs={8}>
                                    <GroupedColumnChart
                                        datasets={dataSets}
                                        xaxisLabel={selectedCategory.xaxisLabel}
                                        xaxisData={xaxisData}
                                        yaxisLabel={selectedCategory.yaxisLabel}
                                        MaxBarNum={1}
                                        label={selectedCategory.chartLabel}
                                        category={selectedCategory}
                                    />
                                </LegacyGrid>
                            )}
                            {selectedCategory !== undefined && doughnutLabel !== undefined && doughnutLabel.length > 0 && doughnutData !== undefined && doughnutData.length > 0 && (
                                <LegacyGrid item xs={4}>
                                    <DoughnutChart
                                        label={doughnutLabel}
                                        data={doughnutData}
                                        imageNames={doughnutImageNames}
                                        category={selectedCategory}
                                        defaultTextCategory={1}
                                        height={300}
                                    />
                                </LegacyGrid>
                            )}
                        </LegacyGrid>
                        {dataTableRenderer(classes, isinitialLoading, selectedCategory, rows, totalRows, this.refreshChart.bind(this), this.loadTableData.bind(this),
                            this.handleExport.bind(this), isLoading)}
                    </div>) : <Paper className={classes.message}>No data available</Paper>} </Grid>
        );
    }
}

export default withStyles(styles)(TeamTrainingAuthorizations);
